(function () {
  'use strict';

  function initSculptFit(root) {
    if (!root || root.dataset.npReady === 'true') return;
    root.dataset.npReady = 'true';

    var gallery = root.querySelector('[data-np-gallery]');
    if (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-np-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-np-thumb]'));
      var currentNode = gallery.querySelector('[data-np-current]');
      var index = 0;
      var touchStart = null;
      var preloadCache = Object.create(null);

      function preloadNext(position) {
        if (slides.length < 2) return;
        var nextSlide = slides[(position + 1) % slides.length];
        var image = nextSlide && nextSlide.querySelector('img');
        if (!image) return;
        var source = image.currentSrc || image.src;
        if (!source || preloadCache[source]) return;
        var preload = new Image();
        preload.decoding = 'async';
        if (image.sizes) preload.sizes = image.sizes;
        if (image.srcset) preload.srcset = image.srcset;
        preload.src = source;
        preloadCache[source] = preload;
        preload.addEventListener('error', function () { delete preloadCache[source]; }, { once: true });
      }

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        thumbs.forEach(function (thumb, thumbIndex) {
          var active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
        if (currentNode) currentNode.textContent = String(index + 1);
        preloadNext(index);
      }

      var prev = gallery.querySelector('[data-np-prev]');
      var next = gallery.querySelector('[data-np-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { show(Number(thumb.getAttribute('data-np-thumb')) || 0); });
      });
      gallery.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') show(index - 1);
        if (event.key === 'ArrowRight') show(index + 1);
      });
      gallery.addEventListener('touchstart', function (event) {
        touchStart = event.touches && event.touches[0] ? event.touches[0].clientX : null;
      }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        if (touchStart === null || !event.changedTouches || !event.changedTouches[0]) return;
        var delta = event.changedTouches[0].clientX - touchStart;
        touchStart = null;
        if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      }, { passive: true });
      preloadNext(0);
    }

    root.querySelectorAll('[data-np-video-card]').forEach(function (card) {
      var video = card.querySelector('video');
      var button = card.querySelector('button');
      if (!video || !button) return;
      function sync() { card.classList.toggle('is-playing', !video.paused); }
      button.addEventListener('click', function () {
        if (video.paused) {
          root.querySelectorAll('[data-np-video-card] video').forEach(function (other) { if (other !== video) other.pause(); });
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('click', function () { button.click(); });
    });

    var form = root.querySelector('#northpower-product-form');
    var variantsNode = root.querySelector('[data-np-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]'); } catch (error) { variants = []; }
    var currency = root.getAttribute('data-currency') || 'EUR';
    var locale = root.getAttribute('data-locale') || 'fr-FR';
    var variantInput = root.querySelector('[data-np-variant-id]');
    var singleBox = root.querySelector('[data-np-single]');
    var packBox = root.querySelector('[data-np-pack]');
    var fixedPackBox = root.querySelector('[data-np-fixed-pack]');
    var priceNode = root.querySelector('[data-np-price]');
    var compareNode = root.querySelector('[data-np-compare]');
    var saveNode = root.querySelector('[data-np-save]');
    var atc = root.querySelector('[data-np-atc]');
    var atcPrice = root.querySelector('[data-np-atc-price]');
    var sticky = root.querySelector('[data-np-sticky]');
    var stickyPrice = root.querySelector('[data-np-sticky-price]');
    var errorNode = root.querySelector('[data-np-error]');
    var i18n = {
      chooseSize: 'Choisir ma taille · ',
      soldOut: 'Épuisé · ',
      addToCart: 'Ajouter au panier · ',
      bundleSizeError: 'Choisissez votre taille pour les trois débardeurs.',
      fixedBundleSizeError: 'Choisissez votre taille pour les sept débardeurs.',
      singleSizeError: 'Choisissez votre taille pour continuer.',
      addError: 'Impossible d’ajouter le produit. Réessayez dans un instant.',
      offerProperty: 'Offre',
      piece1Property: 'Pièce 1',
      piece2Property: 'Pièce 2',
      freePieceProperty: 'Pièce offerte',
      fixedPackProperty: 'Composition du pack',
      sizeProperty: 'Taille',
      singleOffer: '1 SculptFit',
      bundleOffer: '2+1 offert — 3 reçus',
      fixedBundleOffer: '6+1 offert — 7 reçus',
      fixedBundleComposition: '2 Noir · 2 Blanc · 2 Gris · 1 Or (édition limitée)',
      colors: {
        Noir: 'Noir',
        Blanc: 'Blanc',
        Gris: 'Gris',
        'Or (édition limitée)': 'Or (édition limitée)'
      }
    };
    var i18nNode = root.querySelector('[data-np-i18n]');
    if (i18nNode) {
      try {
        var localized = JSON.parse(i18nNode.textContent || '{}');
        Object.keys(localized).forEach(function (key) {
          if (key !== 'colors') i18n[key] = localized[key];
        });
        if (localized.colors) {
          Object.keys(localized.colors).forEach(function (color) { i18n.colors[color] = localized.colors[color]; });
        }
      } catch (error) {
        console.error('SculptFit localization config failed', error);
      }
    }

    function localizedColor(color) {
      return i18n.colors[color] || color;
    }

    function localizedOffer(offer) {
      if (offer.indexOf('6+1') !== -1) return i18n.fixedBundleOffer;
      return offer.indexOf('2+1') !== -1 ? i18n.bundleOffer : i18n.singleOffer;
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(cents || 0) / 100).replace(/\u202f/g, ' ');
      } catch (error) {
        return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    function selectedOffer() {
      var input = form && form.querySelector('input[name="np_offer"]:checked');
      return input ? input.value : '2+1 offert — 3 reçus';
    }

    function findVariant(size, color, offer) {
      return variants.find(function (variant) {
        var options = variant.options || [variant.option1, variant.option2, variant.option3];
        return options[0] === size && options[1] === color && options[2] === offer;
      });
    }

    function packValues() {
      var sizeInput = form.querySelector('input[name="np_pack_size"]:checked');
      var sharedSize = sizeInput ? sizeInput.value : '';
      return Array.prototype.slice.call(root.querySelectorAll('[data-np-piece]')).map(function (piece) {
        var colorInput = piece.querySelector('[data-np-piece-color]:checked');
        return {
          color: colorInput ? colorInput.value : '',
          size: sharedSize
        };
      });
    }

    function selection() {
      var offer = selectedOffer();
      if (offer.indexOf('6+1') !== -1) {
        var fixedSizeInput = form.querySelector('input[name="np_fixed_pack_size"]:checked');
        return { offer: offer, size: fixedSizeInput ? fixedSizeInput.value : '', color: 'Pack fixe', pieces: [], fixed: true, complete: Boolean(fixedSizeInput) };
      }
      if (offer.indexOf('2+1') !== -1) {
        var pieces = packValues();
        return { offer: offer, size: pieces[0].size, color: pieces[0].color, pieces: pieces, fixed: false, complete: pieces.every(function (piece) { return piece.size && piece.color; }) };
      }
      var sizeInput = form.querySelector('input[name="np_single_size"]:checked');
      var colorInput = form.querySelector('input[name="np_single_color"]:checked');
      return { offer: offer, size: sizeInput ? sizeInput.value : '', color: colorInput ? colorInput.value : '', pieces: [], fixed: false, complete: Boolean(sizeInput && colorInput) };
    }

    function offerVariant(offer) {
      return variants.find(function (variant) { return (variant.options || [variant.option1, variant.option2, variant.option3])[2] === offer; });
    }

    function sync() {
      if (!form) return;
      var offer = selectedOffer();
      var bundle = offer.indexOf('2+1') !== -1;
      var fixedBundle = offer.indexOf('6+1') !== -1;
      if (singleBox) singleBox.hidden = bundle || fixedBundle;
      if (packBox) packBox.hidden = !bundle;
      if (fixedPackBox) fixedPackBox.hidden = !fixedBundle;
      if (saveNode) {
        saveNode.hidden = !(bundle || fixedBundle);
        saveNode.textContent = fixedBundle ? (saveNode.getAttribute('data-fixed-label') || 'PACK DE 7') : (saveNode.getAttribute('data-bundle-label') || '2+1 OFFERT');
      }
      var picked = selection();
      var variant = picked.complete ? findVariant(picked.size, picked.color, picked.offer) : null;
      var representative = variant || offerVariant(offer);
      if (variantInput) variantInput.value = variant ? variant.id : '';
      if (representative) {
        if (priceNode) priceNode.textContent = money(representative.price);
        if (atcPrice) atcPrice.textContent = money(representative.price);
        if (stickyPrice) stickyPrice.textContent = money(representative.price);
        if (compareNode) {
          compareNode.hidden = !(representative.compare_at_price && Number(representative.compare_at_price) > Number(representative.price));
          compareNode.textContent = compareNode.hidden ? '' : money(representative.compare_at_price);
        }
      }
      var available = Boolean(variant && variant.available !== false);
      if (atc) {
        atc.disabled = false;
        if (!picked.complete) atc.firstChild.nodeValue = i18n.chooseSize;
        else if (!available) atc.firstChild.nodeValue = i18n.soldOut;
        else atc.firstChild.nodeValue = i18n.addToCart;
      }
      if (sticky) {
        sticky.disabled = Boolean(picked.complete && !available);
        sticky.firstChild.nodeValue = !picked.complete ? i18n.chooseSize : (!available ? i18n.soldOut : i18n.addToCart);
      }
      if (errorNode) errorNode.hidden = true;
    }

    if (form) {
      form.addEventListener('change', sync);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (form.dataset.busy === 'true') return;
        var picked = selection();
        var variant = picked.complete ? findVariant(picked.size, picked.color, picked.offer) : null;
        if (!picked.complete || !variant) {
          if (errorNode) {
            errorNode.textContent = picked.offer.indexOf('6+1') !== -1 ? i18n.fixedBundleSizeError : (picked.offer.indexOf('2+1') !== -1 ? i18n.bundleSizeError : i18n.singleSizeError);
            errorNode.hidden = false;
            errorNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        if (variant.available === false) return;
        var properties = {};
        properties[i18n.offerProperty] = localizedOffer(picked.offer);
        if (picked.pieces.length) {
          properties[i18n.piece1Property] = localizedColor(picked.pieces[0].color) + ' · ' + picked.pieces[0].size;
          properties[i18n.piece2Property] = localizedColor(picked.pieces[1].color) + ' · ' + picked.pieces[1].size;
          properties[i18n.freePieceProperty] = localizedColor(picked.pieces[2].color) + ' · ' + picked.pieces[2].size;
        }
        if (picked.fixed) {
          properties[i18n.fixedPackProperty] = i18n.fixedBundleComposition;
          properties[i18n.sizeProperty] = picked.size;
        }
        form.dataset.busy = 'true';
        if (atc) atc.disabled = true;
        if (sticky) sticky.disabled = true;
        document.dispatchEvent(new CustomEvent('cart:add', {
          detail: {
            source: 'northpower-product',
            items: [{ id: Number(variant.id), quantity: 1, properties: properties }],
            onSuccess: function () { form.dataset.busy = 'false'; sync(); },
            onError: function (error) {
              console.error('SculptFit add-to-cart failed', error);
              form.dataset.busy = 'false';
              if (errorNode) { errorNode.textContent = i18n.addError; errorNode.hidden = false; }
              sync();
            }
          }
        }));
      });
      sync();
    }

    if (sticky && form) sticky.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : atc.click(); });
    if (atc && sticky && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0); });
      }, { threshold: 0.05 });
      observer.observe(atc);
    }

    var modal = root.querySelector('[data-np-size-modal]');
    root.querySelectorAll('[data-np-size-guide]').forEach(function (button) {
      button.addEventListener('click', function () { if (modal) { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; } });
    });
    root.querySelectorAll('[data-np-size-close]').forEach(function (button) {
      button.addEventListener('click', function () { if (modal) { modal.hidden = true; document.documentElement.style.overflow = ''; } });
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && modal && !modal.hidden) { modal.hidden = true; document.documentElement.style.overflow = ''; } });

    var reviewViewport = root.querySelector('[data-np-review-viewport]');
    if (reviewViewport) {
      var reviewCards = Array.prototype.slice.call(reviewViewport.querySelectorAll('.np-review-card'));
      var reviewCurrent = root.querySelector('[data-np-review-current]');
      function reviewIndex() {
        if (!reviewCards.length) return 0;
        var viewportLeft = reviewViewport.getBoundingClientRect().left;
        var nearest = 0;
        var distance = Infinity;
        reviewCards.forEach(function (card, cardIndex) {
          var delta = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (delta < distance) { distance = delta; nearest = cardIndex; }
        });
        return nearest;
      }
      function goReview(direction) {
        var target = (reviewIndex() + direction + reviewCards.length) % reviewCards.length;
        reviewViewport.scrollTo({ left: reviewCards[target].offsetLeft - reviewCards[0].offsetLeft, behavior: 'smooth' });
      }
      var reviewPrev = root.querySelector('[data-np-review-prev]');
      var reviewNext = root.querySelector('[data-np-review-next]');
      if (reviewPrev) reviewPrev.addEventListener('click', function () { goReview(-1); });
      if (reviewNext) reviewNext.addEventListener('click', function () { goReview(1); });
      reviewViewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); goReview(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); goReview(1); }
      });
      reviewViewport.addEventListener('scroll', function () {
        if (reviewCurrent) reviewCurrent.textContent = String(reviewIndex() + 1);
      }, { passive: true });
    }

    var proofViewport = root.querySelector('[data-np-proof-viewport]');
    if (proofViewport) {
      var proofCards = Array.prototype.slice.call(proofViewport.querySelectorAll('.np-proof-card'));
      var proofCurrent = root.querySelector('[data-np-proof-current]');
      function proofIndex() {
        if (!proofCards.length) return 0;
        var viewportLeft = proofViewport.getBoundingClientRect().left;
        var nearest = 0;
        var distance = Infinity;
        proofCards.forEach(function (card, cardIndex) {
          var delta = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (delta < distance) { distance = delta; nearest = cardIndex; }
        });
        return nearest;
      }
      function goProof(direction) {
        var target = (proofIndex() + direction + proofCards.length) % proofCards.length;
        proofViewport.scrollTo({ left: proofCards[target].offsetLeft - proofCards[0].offsetLeft, behavior: 'smooth' });
      }
      var proofPrev = root.querySelector('[data-np-proof-prev]');
      var proofNext = root.querySelector('[data-np-proof-next]');
      if (proofPrev) proofPrev.addEventListener('click', function () { goProof(-1); });
      if (proofNext) proofNext.addEventListener('click', function () { goProof(1); });
      proofViewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); goProof(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); goProof(1); }
      });
      proofViewport.addEventListener('scroll', function () {
        if (proofCurrent) proofCurrent.textContent = String(proofIndex() + 1);
      }, { passive: true });
    }
  }

  function init() { initSculptFit(document.querySelector('[data-np-page]')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
